import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categories, featuredArticles, articles } from '@/mocks/articles';
import { statsData, faqData } from '@/mocks/homeData';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '六合宝典',
  url: 'https://liuhebaodian.com',
  description: '六合宝典是玩家必备的权威参考工具，收录完整玩法规则、历史数据分析、号码走势图表及专业解读。',
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '六合宝典',
  url: 'https://liuhebaodian.com',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://liuhebaodian.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<string | null>(null);

  return (
    <>
      <title>六合宝典·官方权威指南 | 玩法全解析</title>
      <meta
        name="description"
        content="六合宝典是玩家必备的权威参考工具，收录完整玩法规则、历史数据分析、号码走势图表及专业解读。本站提供最全面的六合宝典内容，助您系统掌握规律，理性参考，科学分析每期数据。"
      />
      <meta
        name="keywords"
        content="六合宝典,六合宝典玩法解析,六合宝典历史数据,六合宝典号码走势,六合宝典规则大全,六合宝典图库参考,六合宝典开奖记录"
      />
      <link rel="canonical" href="https://liuhebaodian.com/" />
      <meta property="og:title" content="六合宝典·官方权威指南 | 玩法全解析" />
      <meta
        property="og:description"
        content="六合宝典是玩家必备的权威参考工具，收录完整玩法规则、历史数据分析、号码走势图表及专业解读。"
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://liuhebaodian.com/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="六合宝典·官方权威指南 | 玩法全解析" />
      <meta
        name="twitter:description"
        content="六合宝典是玩家必备的权威参考工具，收录完整玩法规则、历史数据分析、号码走势图表及专业解读。"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema),
        }}
      />

      <div>
        {/* Hero Section */}
        <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20traditional%20red%20and%20gold%20abstract%20background%20with%20flowing%20ribbon%20patterns%2C%20elegant%20luminous%20geometric%20shapes%2C%20warm%20oriental%20atmosphere%2C%20soft%20dramatic%20lighting%2C%20minimalist%20artistic%20composition%2C%20deep%20crimson%20and%20amber%20gradients&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
              alt="六合宝典权威指南"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
                <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
                <span className="text-sm text-background-50/90 font-medium">
                  权威参考 · 理性分析 · 科学决策
                </span>
              </div>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 mb-6 leading-tight">
                六合宝典
                <span className="block text-2xl md:text-3xl lg:text-4xl mt-3 text-background-50/80 font-normal">
                  官方权威指南
                </span>
              </h1>
              <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
                收录完整玩法规则、历史数据分析、号码走势图表及专业解读，助您系统掌握规律，理性参考，科学分析每期数据。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/category/wanfa-jiexi"
                  className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-book-open-line mr-2"></i>
                  开始学习
                </Link>
                <Link
                  to="/category/kaijiang-jilu"
                  className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-record-circle-line mr-2"></i>
                  开奖记录
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
            <div className="w-6 h-10 rounded-full border-2 border-background-50/40 flex items-start justify-center p-1.5">
              <div className="w-1 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-20">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {statsData.map((stat) => (
                <div
                  key={stat.id}
                  className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/70"
                >
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100">
                    <i className={`${stat.icon} text-lg text-primary-600`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
                内容分类
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                六大知识板块，全面覆盖六合彩各类信息需求
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-500 transition-colors">
                      <i
                        className={`${cat.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors`}
                      ></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading text-lg text-foreground-900 mb-1">
                        {cat.name}
                      </h3>
                      <p className="text-sm text-foreground-500 leading-relaxed mb-2 line-clamp-2">
                        {cat.description}
                      </p>
                      <span className="text-xs text-foreground-400">
                        {cat.articleCount} 篇文章
                      </span>
                    </div>
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-line text-foreground-400"></i>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles Section */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-2">
                  精选文章
                </h2>
                <p className="text-foreground-500 text-sm">
                  编辑推荐的高质量内容
                </p>
              </div>
              <Link
                to="/category/wanfa-jiexi"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {featuredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="relative h-44 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={`${article.title} - 六合宝典`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-700">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>{article.readTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <div className="mt-8 text-center sm:hidden">
              <Link
                to="/category/wanfa-jiexi"
                className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
              >
                查看全部文章
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Latest Articles Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
                最新文章
              </h2>
              <p className="text-foreground-500 max-w-xl mx-auto">
                持续更新，为您带来最新的六合彩资讯与分析
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              {articles.slice(4, 8).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="flex-shrink-0 w-full sm:w-40 h-28 rounded-lg overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={`${article.title} - 六合宝典`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-xs font-medium text-secondary-700">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">
                        {article.readTime}
                      </span>
                    </div>
                    <h3 className="font-heading text-base text-foreground-900 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                      {article.excerpt}
                    </p>
                    <span className="text-xs text-foreground-400">
                      {article.publishDate}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-foreground-500">快速了解六合宝典</p>
            </div>
            <div className="space-y-3">
              {faqData.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() =>
                      setOpenFaq(openFaq === faq.id ? null : faq.id)
                    }
                  >
                    <span className="font-medium text-foreground-900 text-sm pr-4">
                      {faq.question}
                    </span>
                    <div
                      className={`flex-shrink-0 w-5 h-5 flex items-center justify-center transition-transform duration-300 ${
                        openFaq === faq.id ? 'rotate-180' : ''
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-foreground-400"></i>
                    </div>
                  </button>
                  {openFaq === faq.id && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
              开启您的六合宝典之旅
            </h2>
            <p className="text-foreground-500 mb-8 max-w-xl mx-auto">
              从基础玩法到高级分析，六合宝典为您提供一站式参考服务
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/wanfa-jiexi"
                className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即探索
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full border border-foreground-200 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}